// Deprecated; use formatDate instead
const dateFormat = (date, options = {}) => {
  const newDate = Date.parse(date);
  return new Intl.DateTimeFormat('en-US', options).format(newDate);
};

export default dateFormat;

// For timestamps where the time of day matters, such as an action the user can
// repeat several times a day and needs to confirm just happened.
export function formatDateTime(date) {
  const parts = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(Date.parse(date));
  const value = type => parts.find(part => part.type === type).value;

  return `${value('year')}-${value('month')}-${value('day')} ${value('hour')}:${value('minute')}`;
}

export function formatDate(date) {
  const format = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const [month, , day, , year] = format.formatToParts(Date.parse(date));
  return `${year.value}-${month.value}-${day.value}`;
}
